import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {styled} from "@mui/material/styles"

import {Prop, PropLabel, Props, PropValue} from "@indebted/components/Props"
import {Page} from "@indebted/components/Page"
import {PaymentCompletedImage} from "@indebted/assets"

function PaymentSucceeded({ClientName, Amount, I18n}) {
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{I18n.PaymentSucceeded.Title}
				</Typography>
			</Grid>

			<Grid>
				<Typography align="center">{I18n.PaymentSucceeded.Subtitle}</Typography>
			</Grid>

			<GridImage>
				<PaymentCompletedImage />
			</GridImage>

			<Props>
				<Prop>
					<PropLabel align="right">{I18n.PaymentSucceeded.PaymentAmountLabel}</PropLabel>
					<PropValue align="left">{Amount}</PropValue>
				</Prop>
				<Prop>
					<PropLabel align="right">{I18n.PaymentSucceeded.PaidToLabel}</PropLabel>
					<PropValue align="left" className="amp-mask">
						{ClientName}
					</PropValue>
				</Prop>
			</Props>
		</Page>
	)
}

const GridImage = styled(Grid)`
	margin: ${(props) => props.theme.spacing(5)};
`

export {PaymentSucceeded}
